import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const BlueGroupIcon = ({ className, fill = "#2e2e2e" }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <g clip-path="url(#clip0_177531_14029)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#2196F3"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.1882 6.03395C17.5047 6.03406 17.8166 6.1107 18.0971 6.25735C18.3777 6.404 18.6186 6.6163 18.7994 6.87617C18.9802 7.13604 19.0954 7.43576 19.1353 7.7498C19.1753 8.06383 19.1387 8.38286 19.0287 8.67969C18.9186 8.97653 18.7385 9.24236 18.5036 9.45454C18.2686 9.66672 17.9859 9.81895 17.6794 9.89825C17.373 9.97755 17.0519 9.98158 16.7435 9.90999C16.4352 9.8384 16.1487 9.69331 15.9085 9.4871L15.9051 9.49131C15.9093 9.41655 15.9116 9.34099 15.9116 9.26542C15.9124 8.56336 15.7229 7.87421 15.3632 7.27131C15.5084 6.90598 15.76 6.59269 16.0854 6.37204C16.4108 6.15139 16.7949 6.03356 17.188 6.03381L17.1882 6.03395ZM20.6382 13.2729V14.6885H17.6597C17.5299 14.1206 17.315 13.5757 17.0222 13.0721C16.6046 12.3567 16.0395 11.7383 15.3646 11.2581C15.4569 11.1033 15.5383 10.9423 15.6083 10.7763C16.1687 11.0953 16.8126 11.2372 17.4552 11.1832C18.0979 11.1292 18.709 10.8818 19.2083 10.4736C19.6502 10.7927 20.0101 11.212 20.2587 11.697C20.5073 12.1821 20.6375 12.7191 20.6385 13.2641V13.273L20.6382 13.2729ZM16.5737 15.9916C16.5737 15.9893 16.5737 15.9869 16.5737 15.985C16.571 15.2404 16.3874 14.5076 16.0386 13.8498C15.6898 13.1919 15.1863 12.6287 14.5714 12.2086C13.8608 12.8299 12.949 13.1723 12.005 13.1723C11.0611 13.1723 10.1492 12.8299 9.43863 12.2086C8.82392 12.6289 8.32051 13.1923 7.97167 13.8502C7.62284 14.5081 7.43902 15.2409 7.43603 15.9855V15.9917V17.9661H16.5738V15.9917L16.5737 15.9916ZM6.35027 14.6885H3.36719V13.2729C3.36719 13.2706 3.36719 13.2675 3.36719 13.2648C3.36808 12.7196 3.49816 12.1824 3.74675 11.6973C3.99534 11.2121 4.35538 10.7927 4.79734 10.4735C5.29725 10.8823 5.90935 11.1298 6.55285 11.1834C7.19634 11.237 7.84096 11.0942 8.40161 10.7738C8.47167 10.9407 8.55332 11.1025 8.64597 11.258C7.48515 12.0804 6.66796 13.3016 6.35045 14.6884L6.35027 14.6885ZM6.81714 6.03405C7.21117 6.0338 7.59615 6.15218 7.92197 6.37377C8.24778 6.59537 8.49934 6.90992 8.64391 7.27647C8.28583 7.87806 8.0972 8.56533 8.098 9.26542C8.098 9.34328 8.10072 9.42077 8.10536 9.4975L8.09598 9.4871C7.85578 9.69336 7.56927 9.83848 7.26086 9.91008C6.95246 9.98169 6.63131 9.97765 6.3248 9.89831C6.01829 9.81898 5.73552 9.6667 5.50058 9.45447C5.26564 9.24223 5.08551 8.97632 4.97554 8.67943C4.86558 8.38253 4.82904 8.06344 4.86904 7.74937C4.90904 7.4353 5.0244 7.13556 5.20528 6.87571C5.38616 6.61585 5.62719 6.40359 5.90783 6.25702C6.18847 6.11045 6.50039 6.03392 6.817 6.03395L6.81714 6.03405ZM12.005 6.59214C12.5338 6.59215 13.0506 6.74895 13.4902 7.04271C13.9299 7.33646 14.2725 7.75399 14.4748 8.24248C14.6772 8.73097 14.7301 9.26848 14.6269 9.78706C14.5238 10.3056 14.2692 10.782 13.8953 11.1558C13.5214 11.5297 13.0451 11.7843 12.5265 11.8874C12.0079 11.9906 11.4704 11.9376 10.9819 11.7353C10.4934 11.5329 10.0759 11.1903 9.78217 10.7507C9.48843 10.311 9.33165 9.79416 9.33166 9.26542C9.33243 8.55665 9.61433 7.87712 10.1155 7.37594C10.6167 6.87477 11.2963 6.59289 12.005 6.59214Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_177531_14029">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BlueGroupIcon;
